import { ReactNode } from 'react';
import HoverHint from '@/components/ui/Tooltip/HoverHint';
import styles from './StateChip.module.scss';

export type StateTone = 'grey' | 'amber' | 'green';

interface StateChipProps {
  tone: StateTone;
  children: ReactNode;
  /** A dot before the text, for lists where the colour alone is too quiet. */
  dot?: boolean;
  /** Why the state is what it is, in the site's tooltip on hover. */
  hint?: ReactNode;
  className?: string;
}

/**
 * A state, coloured the same way everywhere in the management screens (HAT-1489): grey for
 * closed / off, amber for partly open / waiting, green for open / shown / sent.
 */
const StateChip = ({ tone, children, dot = false, hint, className = '' }: StateChipProps) => (
  <HoverHint hint={hint} className={`${styles.chip} ${styles[tone]} ${className} body-xs-semibold`}>
    {dot && <span className={styles.dot} aria-hidden="true" />}
    {children}
  </HoverHint>
);

export default StateChip;
